import moment from 'moment'

export default {
    data() {
        return {
            mobileWidth: 426,
            listStatus: [
                {
                    id: -1,
                    text: "Tất cả",
                    styleClass: 'badge badge-light',
                    sortOrder: -1,
                },
                {
                    id: 0,
                    text: "Chưa hoàn thành",
                    styleClass: 'badge badge-light',
                    sortOrder: 0,
                },
                {
                    id: 1,
                    text: "Hoàn thành",
                    styleClass: 'badge badge-secondary',
                    sortOrder: 1,
                },
                {
                    id: 2,
                    text: "Đã hủy",
                    styleClass: 'badge badge-secondary',
                    sortOrder: 2,
                },

            ],
            precedenceEnum: [
                {},
                {},
                {},
                {
                    text: 'Đặc biệt',
                    value: 3,
                    star: 3
                },
                {
                    text: 'Bình thường',
                    value: 4,
                    star: 2
                },
                {
                    text: 'Thấp',
                    value: 5,
                    star: 1
                }
            ],
            orderCustmerStatus: [
                {
                    id: 0,
                    text: "Chưa hoàn thành",
                    styleClass: '',
                    sortOrder: 0
                },
                {
                    id: 1,
                    text: "Hoàn thành",
                    styleClass: 'badge badge-light',
                    sortOrder: 1,
                },
                {
                    id: 2,
                    text: "Đã hủy",
                    styleClass: 'badge badge-secondary',
                    sortOrder: 2,
                },
            ],
        }
    },
    methods: {
        formatDateTime(value) {
            if (value) {
                return moment(String(value)).format('HH:mm DD-MM-YYYY')
            }
        },
        formatDateTimeVN(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY HH:mm');
            }
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        formatDateDB(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        formatNumber(amount, decimalCount = 2, decimal = ".", thousands = ",") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        }
    },
}